<template>
  <div>
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="page-breadcrumb border-bottom">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-xs-12 align-self-center">
          <h5 class="mb-0 font-medium text-uppercase">Users Managers <span class="badge badge-primary">{{count}}</span></h5>
        </div>
        <div class="col-lg-9 col-md-8 col-xs-12 align-self-center">
          <button
            class="float-right ml-3 text-white btn btn-primary d-none d-md-block"
            @click="addUser"
          >
            <i class="fas fa-plus"></i> Add user
          </button>
          <nav aria-label="breadcrumb" class="float-left mt-2 float-md-right">
            <ol class="p-0 mb-0 breadcrumb justify-content-end">
              <li class="breadcrumb-item">
                <a>Home</a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">Users Managers</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="page-content container-fluid">
      <!-- ============================================================== -->
      <!-- Start Page Content -->
      <!-- ============================================================== -->

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="form-group col-4">
                  <div class="input-group">
                    <span class="input-group-btn">
                      <button type="button" class="btn waves-effect waves-light btn-info">
                        <i class="fa fa-search"></i>
                      </button>
                    </span>
                    <input v-model="textSearch" type="text" class="form-control" placeholder="Search by email" @change="searchUser()"/>
                  </div>
                </div>
                <div class="form-group col-4">
                  <b-form-select v-model="selectedIdentifyProvider" :options="options" @change="searchUser()" />
                </div>
              </div>
              <div class="table-responsive">
                <div class="text-center">
                  <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>A/B</th>
                      <th>Email</th>
                      <th>Identify Provider</th>
                      <th>Full Name</th>
                      <th>Created At</th>
                      <th>Role</th>
                      <th>Stripe</th>
                      <th>Status</th>
                      <th>Login</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in items"
                      :key="index"
                      class="pointer"
                      @click="openDetailUser(item)"
                    >
                      <td>{{item.id}}</td>
                      <td>{{item.id % 4}}</td>
                      <td>
                        <div class="d-flex align-items-center">
                          <span>{{item.email || item.providerUserEmail}}</span>
                          <span v-if="item.plan != 'free'" class="ml-1 badge badge-primary text-uppercase">
                            {{item.plan}}
                          </span>
                          <span v-if="item.hasSalesContract" class="ml-1 badge badge-success">Enterprise</span>
                        </div>
                      </td>
                      <td>{{item.identifyProvider}}</td>
                      <td>{{item.firstName}} {{item.lastName}}</td>
                      <td>{{item.createdAt | dateTime}}</td>
                      <td class="text-bold">
                        <span :class="'badge badge-' + item.roleColor">{{item.role}}</span>
                      </td>
                      <td>
                        <span
                          class="badge"
                          :class="item.stripeSource === 'singapore' ? 'badge-success' : 'badge-secondary'"
                        >
                          {{ item.stripeSource }}
                        </span>
                      </td>
                      <td>
                        <span v-if="item.active" class="badge badge-success">Active</span>
                        <span v-if="!item.active" class="badge badge-secondary">Inactive</span>
                      </td>
                      <td @click.stop="goToPresenterSide(item)">
                        <i class="fas fa-eye"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="overflow-auto">
                  <b-pagination v-model="page" :total-rows="count" per-page="100"></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Config from "@/config"
import Constant from "@/constant"
import AccountsAPI from "@/api/accounts"

export default {
  name: "Users",
  data() {
    return {
      items: [],
      page: 1,
      count: 0,
      isLoading: false,
      textSearch: "",
      selectedIdentifyProvider: null,
      options: [
        { value: null, text: 'All' },
        { value: 'skoletube', text: 'Skoletube' },
      ],
    }
  },
  created() {
    this.getData()
  },
  mounted() {},
  watch: {
    page: {
      handler: function() {
        this.getData()
      },
      deep: true
    }
  },
  methods: {
    searchUser () {
      this.getData()
    },
    async getData() {
      this.isLoading = true
      this.$http
        .get(Config.api.getListUsers, {
          params: {
            page: this.page,
            textSearch: this.textSearch,
            identifyProvider: this.selectedIdentifyProvider,
          }
        })
        .then(async res => {
          this.isLoading = false
          res.body.result.map(item => {
            item.roleColor = Constant.roleSetting[item.role].color
            return item
          })
          this.items = res.body.result
          this.count = res.body.count
          this.items.forEach(item => {
            item.plan = item.plan.replace("-"," ")
          })
          
          // Get sales-assisted-contract data
          await this.getSalesContracts()
        })
    },
    async getSalesContracts() {
      if (this.items.length === 0) return
      
      try {
        // Extract unique account IDs from users who have an accountId
        const accountIds = [...new Set(this.items
          .filter(item => item.accountId)
          .map(item => item.accountId)
        )]
        
        if (accountIds.length === 0) return
        
        // Call the sales-assisted-contract API
        const salesContracts = await AccountsAPI.getSalesAssistedContract({ accountIds })
        
        // Merge sales data with items
        this.items = this.items.map(item => {
          const hasContract = item.accountId && salesContracts.some(contract => contract.teamid === item.accountId)
          return {
            ...item,
            hasSalesContract: hasContract
          }
        })
      } catch (error) {
        console.error('Error fetching sales contracts:', error)
      }
    },
    openDetailUser(item) {
      if (item.role == "master") return
      this.$router.push({ name: "UserDetail", params: { id: item.id } })
    },
    addUser() {
      this.$router.push({ name: "UserDetail", params: { id: "new" } })
    },

    goToPresenterSide(item) {
      if (item.isLoading) return
      item.isLoading = true
      this.$http
        .get(Config.api.getTokenPresenter, {
          params: {
            id: item.id
          }
        })
        .then(res => {
          if (item.whiteLabelPresenterDomain) {
            let url = item.whiteLabelPresenterDomain.includes('http') ? 
              `${item.whiteLabelPresenterDomain}/pages/token?token=${res.body}&admin=true`:
             `https://${item.whiteLabelPresenterDomain}/pages/token?token=${res.body}&admin=true`
            window.open(url, '_blank', "noopener")
          } else {
            let url = `${Config.presenterUrl}/pages/token?token=${res.body}&admin=true"`
            window.open(url, "_blank", "noopener")
            item.isLoading = false
          }

        })
    }
  }
}
</script>
<style lang="scss" scoped>
// .addUser-btn {
//   background-color: #4f9af2;
//   border-radius: 20px;
//   border-color: #4f9af2;
//   &:hover {
//     background-color: #2785f0;
//     border-color: #2785f0;
//   }
// }
</style>
